module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-wayo@3x-fef3f42963b3f86f62c50c44fcb9ce9d.webp";